'use client'

import React from 'react'
import Image from 'next/image'
import { BrandVars } from '@quark/theme'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { eventConfig } from '@configs/contactus.config'
import { ArrowRight } from '@quark/icons'
import styles from './styles.module.scss'

const CommsCard = ({ data, onCtaClick }) => {
  const { tag, title, cta, Modal } = data.attributes
  const tagIconAttributes = tag.tag_icon?.data?.attributes
  const {
    url: tagIconUrl,
    alternativeText: tagIconAlt,
    width: tagIconWidth,
    height: tagIconHeight,
  } = tagIconAttributes || {}

  const handleClick = async () => {
    onCtaClick(Modal)
    const ctaType = cta.Type
    const event = eventConfig[ctaType]

    if (event) {
      await trackEvent(event.eventName, {
        ...event.eventProps,
        platform: getDevicePlatform(),
      })
    }
  }

  return (
    <div
    className={styles.card}
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={handleClick}
      style={{
        ['--iconBorder' as any]: BrandVars.Icon['base/primary'],
        ['--iconBg' as any]: BrandVars.Surface['base/overlay'],
        ['--hoverIconBg' as any]: BrandVars.Icon['base/primary'],
      }}>
      <h3 className={styles.title}>{title}</h3>
      <div className={`${styles.tag} ${styles[`tag--${tag.colorScheme}`]}`}>
        {tagIconAttributes && (
          <Image
            src={tagIconUrl}
            alt={tagIconAlt || 'tag icon'}
            width={tagIconWidth || 16}
            height={tagIconHeight || 16}
            className={styles.tagIcon}
          />
        )}
        {tag.text}
      </div>
      <span className={styles.cta}>
        {cta.Title}
        <ArrowRight />
      </span>
    </div>
  )
}

export default CommsCard
